import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import _Symbol$iterator from "babel-runtime/core-js/symbol/iterator";
import _Object$defineProperty from "babel-runtime/core-js/object/define-property";
import _Object$getOwnPropertyDescriptor from "babel-runtime/core-js/object/get-own-property-descriptor";
/**
 * @license
 * This work is a derivative of the Google Neuroglancer project,
 * Copyright 2016 Google Inc.
 * The Derivative Work is covered by
 * Copyright 2019 Howard Hughes Medical Institute
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = _Object$getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && _Object$defineProperty(target, key, r), r;
};
var Uint64Map_1;
import { HashMapUint64 } from "./gpu_hash/hash_table";
import { Signal } from "./util/signal";
import { registerRPC, registerSharedObject, SharedObjectCounterpart } from "./worker_rpc";
let Uint64Map = Uint64Map_1 = class Uint64Map extends SharedObjectCounterpart {
    constructor() {
        super(...arguments);
        this.hashTable = new HashMapUint64();
        this.changed = new Signal();
    }
    get value() {
        return this;
    }
    static makeWithCounterpart(rpc) {
        let obj = new Uint64Map_1();
        obj.initializeCounterpart(rpc);
        return obj;
    }
    set_(key, value) {
        return this.hashTable.set(key, value);
    }
    set(key, value) {
        if (this.set_(key, value)) {
            let rpc = this.rpc;

            if (rpc) {
                rpc.invoke('Uint64Map.set', { 'id': this.rpcId, 'key': key, 'value': value });
            }
            this.changed.dispatch(key, true);
        }
    }
    has(key) {
        return this.hashTable.has(key);
    }
    get(key, value) {
        return this.hashTable.get(key, value);
    }
    [_Symbol$iterator]() {
        return this.hashTable.entries();
    }
    unsafeEntries() {
        return this.hashTable.unsafeEntries();
    }
    delete_(key) {
        return this.hashTable.delete(key);
    }
    delete(key) {
        if (this.delete_(key)) {
            let rpc = this.rpc;

            if (rpc) {
                rpc.invoke('Uint64Map.delete', { 'id': this.rpcId, 'key': key });
            }
            this.changed.dispatch(key, false);
        }
    }
    get size() {
        return this.hashTable.size;
    }
    assignFrom(other) {
        this.clear();
        for (const _ref of other.unsafeEntries()) {
            var _ref2 = _slicedToArray(_ref, 2);

            const key = _ref2[0];
            const value = _ref2[1];

            this.set(key, value);
        }
    }
    clear() {
        if (this.hashTable.clear()) {
            let rpc = this.rpc;

            if (rpc) {
                rpc.invoke('Uint64Map.clear', { 'id': this.rpcId });
            }
            this.changed.dispatch(null, false);
        }
    }
    toJSON() {
        let result = {};
        for (let _ref3 of this.hashTable.unsafeEntries()) {
            var _ref4 = _slicedToArray(_ref3, 2);

            let key = _ref4[0];
            let value = _ref4[1];

            result[key.toString()] = value.toString();
        }
        return result;
    }
};
Uint64Map = Uint64Map_1 = __decorate([registerSharedObject('Uint64Map')], Uint64Map);
export { Uint64Map };
registerRPC('Uint64Map.set', function (x) {
    let obj = this.get(x['id']);
    if (obj.set_(x['key'], x['value'])) {
        obj.changed.dispatch();
    }
});
registerRPC('Uint64Map.delete', function (x) {
    let obj = this.get(x['id']);
    if (obj.delete_(x['key'])) {
        obj.changed.dispatch();
    }
});
registerRPC('Uint64Map.clear', function (x) {
    let obj = this.get(x['id']);
    if (obj.hashTable.clear()) {
        obj.changed.dispatch();
    }
});
//# sourceMappingURL=uint64_map.js.map